import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import CardActions from "@mui/material/CardActions";
import { CardIcon } from "@common/Icon/CardIcon/CardIcon";

interface IParams {
    isIframeDisplayed: boolean;
    closeIframe(): void;
    loadIframe(): void;
}

export const PaymentCardAction = (props: IParams) => {
    const { isIframeDisplayed, closeIframe, loadIframe } = props;
    const { t } = useTranslation(["payment", "common"]);

    return (
        <CardActions className="card-footer">
            <Grid className="payment-add" container justifyContent="center">
                {isIframeDisplayed && (
                    <Grid item md={3} sm={4} xs={6}>
                        <Button
                            className="card-footer__button"
                            color="inherit"
                            fullWidth
                            size="large"
                            onClick={closeIframe}
                        >
                            {t("common:cancel")}
                        </Button>
                    </Grid>
                )}
                {!isIframeDisplayed && (
                    <Grid item md={4} sm={5} xs={12}>
                        <Button
                            className="card-footer__button"
                            color="inherit"
                            fullWidth
                            size="large"
                            onClick={loadIframe}
                        >
                            <CardIcon getColor={(theme) => theme.palette.quaternary.main} />
                            {t("payment:addNewCard")}
                        </Button>
                    </Grid>
                )}
            </Grid>
        </CardActions>
    );
};
